/**
 * What a finished quiz says on the storefront card: the score, and the call
 * named beside it. "Them" is the list under the line (`QuizReview`) — the
 * questions worth the call, never the answers. (The builder's own play ends on
 * a scoreboard instead, `components/builder/Scoreboard`.)
 *
 * The line break travels in the string (readers set `whitespace-pre-line`), so
 * no caller can give the two halves two different sizes.
 */
export function resultLine({
  score,
  total,
  name,
}: {
  score: number;
  total: number;
  /** The provider, said the way a person would — a first name. */
  name: string;
}): string {
  return score >= total
    ? `All correct!\nTalk it through with ${name} on a call`
    : `${score}/${total} correct!\nGo through them with ${name} on a call`;
}
